import { Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell, CellFrame } from '@/core/architecture'

type TradeMessageBoxProps = {}

export const TradeMessageBoxSkeleton: Cell<TradeMessageBoxProps> = ({}) => (
  <CellFrame>
    <Stack sx={{ py: 5 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ pb: 2 }}>
        <Stack>
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
        <SkeletonText variant="small" width="25%" />
      </Stack>
      <SkeletonText variant="small" numberOfLine={2} lastWidth="75%" />
      <Stack direction="row-reverse" sx={{ pt: 3 }}>
        <SkeletonText variant="small" width="25%" />
      </Stack>
    </Stack>
    <Skeleton variant="rectangular" width="100%" height={1} />
  </CellFrame>
)
